import { Component, HostBinding, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';

const _c0 = ["*"];
class OptionCardComponent {
    constructor() {
        /**
         * Defines if the component is toggled
         */
        this.toggled = false;
        /**
         * Defines if the component is disabled
         */
        this.disabled = false;
    }
    ngOnInit() { }
}
OptionCardComponent.ɵfac = function OptionCardComponent_Factory(t) { return new (t || OptionCardComponent)(); };
OptionCardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OptionCardComponent, selectors: [["onep-option-card"]], hostVars: 4, hostBindings: function OptionCardComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("onep-option-selected", ctx.toggled)("onep-option-disabled", ctx.disabled);
    } }, inputs: { toggled: "toggled", disabled: "disabled" }, ngContentSelectors: _c0, decls: 1, vars: 0, template: function OptionCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } } });
OptionCardComponent.ctorParameters = () => [];
OptionCardComponent.propDecorators = {
    toggled: [{ type: HostBinding, args: ['class.onep-option-selected',] }, { type: Input }],
    disabled: [{ type: HostBinding, args: ['class.onep-option-disabled',] }, { type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OptionCardComponent, [{
        type: Component,
        args: [{ selector: 'onep-option-card', template: "<ng-content></ng-content>\n" }]
    }], function () { return []; }, { toggled: [{
            type: HostBinding,
            args: ['class.onep-option-selected']
        }, {
            type: Input
        }], disabled: [{
            type: HostBinding,
            args: ['class.onep-option-disabled']
        }, {
            type: Input
        }] }); })();

class OptionCardConditionsComponent {
    constructor() { }
    ngOnInit() { }
}
OptionCardConditionsComponent.ɵfac = function OptionCardConditionsComponent_Factory(t) { return new (t || OptionCardConditionsComponent)(); };
OptionCardConditionsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OptionCardConditionsComponent, selectors: [["onep-option-card-conditions"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function OptionCardConditionsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } } });
OptionCardConditionsComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OptionCardConditionsComponent, [{
        type: Component,
        args: [{ selector: 'onep-option-card-conditions', template: "<ng-content></ng-content>\n" }]
    }], function () { return []; }, null); })();

class OptionCardContentComponent {
    constructor() { }
    ngOnInit() { }
}
OptionCardContentComponent.ɵfac = function OptionCardContentComponent_Factory(t) { return new (t || OptionCardContentComponent)(); };
OptionCardContentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OptionCardContentComponent, selectors: [["onep-option-card-content"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function OptionCardContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
OptionCardContentComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OptionCardContentComponent, [{
        type: Component,
        args: [{
                selector: 'onep-option-card-content',
                template: "<ng-content></ng-content>\n"
            }]
    }], function () { return []; }, null); })();

class OptionCardTitleComponent {
    constructor() { }
    ngOnInit() { }
}
OptionCardTitleComponent.ɵfac = function OptionCardTitleComponent_Factory(t) { return new (t || OptionCardTitleComponent)(); };
OptionCardTitleComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OptionCardTitleComponent, selectors: [["onep-option-card-title"]], ngContentSelectors: _c0, decls: 1, vars: 0, template: function OptionCardTitleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵprojection(0);
    } }, encapsulation: 2 });
OptionCardTitleComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OptionCardTitleComponent, [{
        type: Component,
        args: [{
                selector: 'onep-option-card-title',
                template: "<ng-content></ng-content>\n"
            }]
    }], function () { return []; }, null); })();

class OptionCardModule {
}
OptionCardModule.ɵfac = function OptionCardModule_Factory(t) { return new (t || OptionCardModule)(); };
OptionCardModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: OptionCardModule });
OptionCardModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OptionCardModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    OptionCardComponent,
                    OptionCardConditionsComponent,
                    OptionCardContentComponent,
                    OptionCardTitleComponent
                ],
                imports: [CommonModule],
                exports: [
                    OptionCardComponent,
                    OptionCardConditionsComponent,
                    OptionCardContentComponent,
                    OptionCardTitleComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(OptionCardModule, { declarations: function () { return [OptionCardComponent, OptionCardConditionsComponent, OptionCardContentComponent, OptionCardTitleComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [OptionCardComponent, OptionCardConditionsComponent, OptionCardContentComponent, OptionCardTitleComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { OptionCardComponent, OptionCardConditionsComponent, OptionCardContentComponent, OptionCardModule, OptionCardTitleComponent };

